module.exports = __webpack_public_path__ + "static/media/figmaplugin.51cdc63c.png";